export default __webpack_public_path__ + "static/media/002.ee500697.jpg";